module.exports = __webpack_public_path__ + "static/media/04.28daea49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/04.jpg
// module id = 179
// module chunks = 0